var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVdMuseum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#CD2226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.998H4.5C4.36739 14.998 4.24021 15.0507 4.14645 15.1445C4.05268 15.2383 4 15.3654 4 15.498C4 15.6307 4.05268 15.7578 4.14645 15.8516C4.24021 15.9454 4.36739 15.998 4.5 15.998H16.5C16.6326 15.998 16.7598 15.9454 16.8536 15.8516C16.9473 15.7578 17 15.6307 17 15.498C17 15.3654 16.9473 15.2383 16.8536 15.1445C16.7598 15.0507 16.6326 14.998 16.5 14.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99988 9.49805H4.99988V13.998H6.99988V9.49805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 9.49805H14.0001V13.998H16.0001V9.49805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 13.998V9.49805H7.99988V13.998H9.49988V11.498C9.49988 11.3654 9.55256 11.2383 9.64632 11.1445C9.74009 11.0507 9.86727 10.998 9.99988 10.998H10.9999C11.1325 10.998 11.2597 11.0507 11.3534 11.1445C11.4472 11.2383 11.4999 11.3654 11.4999 11.498V13.998H12.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.725 7.05349L10.725 4.05349C10.6552 4.01832 10.5781 4 10.5 4C10.4219 4 10.3448 4.01832 10.275 4.05349L4.275 7.05349C4.19254 7.09504 4.1232 7.15861 4.07466 7.23715C4.02612 7.3157 4.00028 7.40615 4 7.49849V7.99849C4 8.13109 4.05268 8.25827 4.14645 8.35204C4.24021 8.44581 4.36739 8.49849 4.5 8.49849H16.5C16.6326 8.49849 16.7598 8.44581 16.8536 8.35204C16.9473 8.25827 17 8.13109 17 7.99849V7.49849C16.9997 7.40615 16.9739 7.3157 16.9253 7.23715C16.8768 7.15861 16.8075 7.09504 16.725 7.05349ZM10.5 6.99849C10.3674 6.99849 10.2402 6.94581 10.1464 6.85204C10.0527 6.75827 10 6.63109 10 6.49849C10 6.36588 10.0527 6.2387 10.1464 6.14493C10.2402 6.05116 10.3674 5.99849 10.5 5.99849C10.6326 5.99849 10.7598 6.05116 10.8536 6.14493C10.9473 6.2387 11 6.36588 11 6.49849C11 6.63109 10.9473 6.75827 10.8536 6.85204C10.7598 6.94581 10.6326 6.99849 10.5 6.99849Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdMuseum);
export default __webpack_public_path__ + "static/media/VDMuseum.42d87ffd0eb6ccbb846d21d68335ace9.svg";
export { ForwardRef as ReactComponent };